"use strict";
/**
 * Audio playback constants for LingoShade
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_PLAYBACK_SPEED = exports.MIN_PLAYBACK_SPEED = exports.DEFAULT_PLAYBACK_SPEED = exports.PLAYBACK_SPEEDS = void 0;
/**
 * Available playback speed options for audio content
 * Range from 0.5x (slow) to 1.5x (fast) for learning scenarios
 */
exports.PLAYBACK_SPEEDS = [0.5, 0.75, 1.0, 1.25, 1.5];
/**
 * Default playback speed
 */
exports.DEFAULT_PLAYBACK_SPEED = 1.0;
/**
 * Minimum playback speed allowed
 */
exports.MIN_PLAYBACK_SPEED = 0.5;
/**
 * Maximum playback speed allowed
 */
exports.MAX_PLAYBACK_SPEED = 1.5;
//# sourceMappingURL=audio.js.map